import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@environment';
import type {
  AccommodationCreateOrUpdateRequest,
  AccommodationDetail,
  AccommodationListItem,
} from '@models/accommodations';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CrmAccommodationsService {
  private readonly http = inject(HttpClient);

  private url(waterId: number): string {
    return `${environment.apiUrl}/api/crm/waters/${waterId}/accommodations`;
  }

  getAccommodations(waterId: number): Observable<AccommodationListItem[]> {
    return this.http.get<AccommodationListItem[]>(this.url(waterId));
  }

  getAccommodation(waterId: number, id: number): Observable<AccommodationDetail> {
    return this.http.get<AccommodationDetail>(`${this.url(waterId)}/${id}`);
  }

  createAccommodation(waterId: number, dto: AccommodationCreateOrUpdateRequest): Observable<AccommodationDetail> {
    return this.http.post<AccommodationDetail>(this.url(waterId), dto);
  }

  updateAccommodation(
    waterId: number,
    id: number,
    dto: AccommodationCreateOrUpdateRequest,
  ): Observable<AccommodationDetail> {
    return this.http.put<AccommodationDetail>(`${this.url(waterId)}/${id}`, dto);
  }

  deleteAccommodation(waterId: number, id: number): Observable<void> {
    return this.http.delete<void>(`${this.url(waterId)}/${id}`);
  }

  uploadImage(waterId: number, id: number, file: File): Observable<AccommodationDetail> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<AccommodationDetail>(`${this.url(waterId)}/${id}/image`, formData);
  }
}
